export const getBackendUrl = () => {
  return 'https://ggseco-backend.herokuapp.com/api';
};
